import { useContext } from 'react'
import { FilterContext } from 'features/dashboard/filter/FilterContext'
import NoneAnchor from 'components/NoneAnchor'
import PropTypes from 'prop-types'

const FilterSubMenu = ({ sub }) => {
  const {
    selectedMenu: { domain },
    showFilterFormLayer,
  } = useContext(FilterContext)
  const { key, title, filterType } = sub
  return (
    <li>
      <NoneAnchor
        className="link_searchfilter"
        onClick={() => {
          showFilterFormLayer({
            domain,
            key,
            data: filterType.defaultValue,
          })
          window.scrollTo({ top: 0 })
        }}>
        {title}
      </NoneAnchor>
    </li>
  )
}
FilterSubMenu.propTypes = {
  sub: PropTypes.shape({
    title: PropTypes.string,
    key: PropTypes.string,
    filterType: PropTypes.shape({
      defaultValue: PropTypes.object,
    }),
  }),
}
export default FilterSubMenu
